import { createSelector } from 'reselect';

const selectMember = (state: Redux.State) => state.membership.member;

const selectLoggedInStatus = createSelector(selectMember, (member) => !!member);

export {
	/** @internal */
	selectMember,
	selectLoggedInStatus,
};
